<template>
	<div class="kw_video" v-if="load" :style="fieldInfo.styleSet.pageFieldStyleSet?fieldInfo.styleSet.pageFieldStyleSet.styleSetCode:''" kwName="pageFieldStyleSet">
		<video ref="video" oncontextmenu="return false" controls="controls" :src="GLOBAL.getFileServeUrl()+fileArr[nowIndex].F_MONGOID" :style="fieldInfo.styleSet.pageFieldImageStyleSet?fieldInfo.styleSet.pageFieldImageStyleSet.styleSetCode:''" kwName="pageFieldImageStyleSet" @play="play" @pause="pause" @ended="bindended" @timeupdate="onTimeupdate" :autoplay="fieldInfo.styleSet.ifAutoPlay==1?true:false"></video>
	</div>
</template>
<script>
	import pageUtils from '@/js/page/pageUtil.js';
	import utils from '@/js/utils/util.js';
	export default {
		name: 'kw_video',
		props: {
			fieldInfo: {
				type: Object,
				value: null
			},
			mainId:{
				type:String
			},
			pageSetInfo: {
				type: Object,
				default: null
			},
			dataInfo:{
				type: Object,
				default: function () {
					return {};
				}
			}
		},
		data() {
			return {
				// 访问来源 PC:2 或者 H5:3
				visitSource:utils.checkVisitSource(),
				load: false,
				resourcesSourceType: 0, //文件来源
				nowIndex: 0, //当前资源索引
				textIndex: 0, //词索引
				fileArr: [],
				// 展现形式  ZD_SHOW_TYPE:   1:默认(进度条形式)  2:小程序官方默认
				// 是否能重复播放 ZD_IF_REPEAT: 1：是(默认)  2：否
				// 语音对应的文字 是否显示 是否跟随语音播放 ZD_IF_DISCERN 1：是  2：否(默认)    SENTENCES：识别的结果
				// 背景图片     BG_FILE
				// 文件中文名称  SHOW_NAME
				// 播放次数  F_PREVIEWNUM 
				sliderValue: 0, //控制进度条slider的值
				slider_max: 100, //进度条Max值
				current_process: '00:00',
				total_process: '', //音频文件总时长
				playStatus: false, //播放状态 false暂停 true播放
				prevPlayTime:0
			};
		},
		created() {
			this.initAtiached();
		},
		mounted() {
			
		},
		computed: {},
		components: {},
		methods: {
			// 控制音频的播放与暂停
			startPlayOrPause() {
				return this.playStatus ? this.pause() : this.play()
			},
			// 播放音频
			play() {
				this.playStatus = true;
				this.$refs.video.play();
				console.log("播放----------------------");
			},
			// 暂停音频
			pause() {
				this.playStatus = false
				this.$refs.video.pause()
				console.log("暂停----------------------");
			},
			// 拖动进度条，改变当前时间，index是进度条改变时的回调函数的参数0-100之间，需要换算成实际时间
			changeCurrentTime(index) {
				this.sliderValue = index
				this.current_process = this.timeToMinute(this.sliderValue)
				this.$refs.video.currentTime = this.sliderValue
			},
			// 当音频当前时间改变后，进度条也要改变
			onTimeupdate(res) {
				var that = this;
				var nowIndex = this.nowIndex;
				var arr = this.fileArr[nowIndex].SENTENCES;
				var fieldInfo = that.fieldInfo;
				//当前播放时间节点
				var newSliderValue = parseInt(res.target.currentTime);
				//是否禁止快进
				if(fieldInfo.styleSet && fieldInfo.styleSet.ifBanFast == 1) {
					var maxPlaySecond = that.dataInfo.PLAY_SECOND?that.dataInfo.PLAY_SECOND:0;
					if((newSliderValue - this.sliderValue) > 5 && newSliderValue>maxPlaySecond) {
						that.$refs.video.currentTime = this.sliderValue;
						return;
					}
				}
				this.sliderValue = newSliderValue;
				console.log("-----------------------",res);
				//音频总时长
				this.slider_max = parseInt(res.target.duration)
				console.log("backgroundAudioManager.currentTime===============",that.sliderValue,that.prevPlayTime*10);
				if (!(isNaN(fieldInfo.defaultValStr) && fieldInfo.defaultValStr.indexOf(",") == -1)) {
					if(that.sliderValue > that.prevPlayTime*3) {
						that.getPlayFrequency(that.sliderValue);
						that.prevPlayTime = that.prevPlayTime+1;
					}
				}
				this.current_process = this.timeToMinute(this.sliderValue)
				// console.log(res.target.currentTime, '当前播放进度', res.target.duration, '音频总时长')
				if(arr && arr.length>0) {
					for (let i = 0; i < arr.length - 1; i++) {
						// 播放最后一段时 匹配当前歌词
						if ((arr[arr.length - 1].BeginTime < this.sliderValue) && (this.sliderValue < arr[arr.length - 1].EndTime)) {
							var textIndex = arr[arr.length - 1].newIndex
							this.textIndex = textIndex
							break;
						} else {
							if ((this.sliderValue > arr[i].BeginTime) && (this.sliderValue < arr[i + 1].BeginTime)) {
								//播放时间大于对应歌词时间小于下一句歌词时间就显示当前歌词
								var textIndex = arr[i].newIndex
								this.textIndex = textIndex
								break;
							}
						}
					}
				}
			},
			switchContent(data) {
				// nowIndex 当前为下标
				var nowIndex = this.nowIndex
				let arrLength = this.fileArr.length
				// 上一首
				if (data == '+1') {
					if (arrLength > 1) {
						if (nowIndex < arrLength - 1) {
							nowIndex++
							this.nowIndex = nowIndex
							this.initSliderTime()
							this.play()
						}
						if (nowIndex == arrLength) {
							this.nowIndex = 0
							this.initSliderTime()
							this.play()
						}
					}
				}
				// 上一首
				if (data == '-1') {
					if (arrLength > 1) {
						if (nowIndex > 0) {
							nowIndex--
							this.nowIndex = nowIndex
							this.initSliderTime()
							this.play()
						}
						if (nowIndex == 0) {
							this.nowIndex = arrLength - 1
							this.initSliderTime()
							this.play()
						}
					}
				}
			},
			bindended: function(res) {
				console.log('音频播放结束方法！！！', res);
				// this.sliderValue = 0
				var that = this;
				//调用页面刷新操作
				var kw_look = null;
				that.getParentKwLook(val => {
					kw_look = val
				});
				console.log("kwLook==============", kw_look);
				if(kw_look) {
					//本页刷新
					if(that.fieldInfo.styleSet.overRefreshType == 2) {
						kw_look.refreshevent();
					} else {
						//选项卡刷新
						var pageSetInfo = kw_look.pageSetInfo;
						if(pageSetInfo.tabPageSet){
							for (var i = 0; i < pageSetInfo.tabPageSet.length; i++) {
							if(kw_look.$refs["kw_list_" + i] && kw_look.$refs["kw_list_" + i].length>0) {
								kw_look.$refs["kw_list_" + i][0].initLoadDataInfo();
							}
							}
						}
					}
				}

				var nowIndex = this.nowIndex;
				var fileArr = this.fileArr.length;
				if (fileArr == 1) {
					this.nowIndex = 0
					this.initSliderTime()
				} else {
					// 判断音频个数  如有多个自动播放下一个
					this.switchContent('+1')
				}
			},
			getParentKwLook(callback){
				var parentKwLook;
				this.$emit("getParentKwLook",val => {
					parentKwLook = val
				});
				callback(parentKwLook);
			},
			//初始化判断是否是文件主键 如果是文件主键则获取文件信息 进行逻辑处理 如果直接为文件路径 则进行文件路径的显示
			initAtiached() {
				var that = this;
				var audioUrl = "";
				var fieldInfo = that.fieldInfo;
				var fileArr = [];
				console.log("this.fieldInfo===========",fieldInfo);
				if(fieldInfo.defaultValStr) {
					if (isNaN(fieldInfo.defaultValStr) && fieldInfo.defaultValStr.indexOf(",") == -1) {
						audioUrl = fieldInfo.defaultValStr;
						fileArr = [{
							F_MONGOID: fieldInfo.defaultValStr
						}]
	
						this.fileArr = fileArr
						this.resourcesSourceType = 0
						this.load = true;
						that.$nextTick(function(){
							
							if(that.$refs.video && that.dataInfo) {
								that.$refs.video.currentTime = that.dataInfo.PLAY_SECOND;
								that.sliderValue = that.dataInfo.PLAY_SECOND;
							}
						})
						console.log(fileArr, 'fileArr1111')
					} else {
						var toHtData = {
							'fileId': fieldInfo.defaultValStr
						}
						var url = '/file_getFile.do?source=888'
						that.$axios.post(url, toHtData).then(res => {
							var fileSets = res.data;
							if (fileSets && fileSets.length > 0) {
								fileArr = fileSets;
								fileSets.forEach((item) => {
									if (item.AUDIO_TOTAL_TIME) {
										// 音频总时长
										item.total_process = that.timeToMinute(item.AUDIO_TOTAL_TIME / 1000)
										item.slider_max = parseFloat(item.AUDIO_TOTAL_TIME / 1000)
									}
									if (item.SENTENCES) {
										var SENTENCES = item.SENTENCES
										item.SENTENCES = JSON.parse(SENTENCES).Sentences
										item.SENTENCES.forEach((i, index) => {
											i.newIndex = index
											if (index == 0) {
												i.BeginTime = 0
											} else {
												i.BeginTime = parseFloat(i.BeginTime / 1000)
											}
											if (index == item.SENTENCES.lengtn - 1) {
												i.EndTime = item.slider_max
											} else {
												i.EndTime = parseFloat(i.EndTime / 1000)
											}
										})
									}
								})
								console.log(fileArr, 'fileArr2222------')
							}
							that.fileArr = fileArr
							that.load = true;
							that.$nextTick(function(){
								console.log("this.$refs.video======222===========",that.$refs.video,that.dataInfo);
								if(that.$refs.video && that.dataInfo && that.dataInfo.PLAY_SECOND) {
									that.$refs.video.currentTime = that.dataInfo.PLAY_SECOND;
									that.sliderValue = that.dataInfo.PLAY_SECOND;
								}
							})
							that.resourcesSourceType = 1
						}).catch(error => {
							console.log("服务器异常!", error);
						});
					}
				}
			},
			// 初始化进度条和时间
			initSliderTime(){
				this.sliderValue = 0
				this.current_process = '00:00'
				this.textIndex = 0
			},
			getPlayFrequency(time){
				var that = this;
				var fileArr = this.fileArr;
				var nowIndex = this.nowIndex;
				var slider_max = this.slider_max;
				var toHtData = {}
				toHtData.dataIds = fileArr[nowIndex].F_ID
			    toHtData.pageId = 0 
			    toHtData.tableId = 4
			    toHtData.buttonType =21
			    toHtData.directSetIds = ',1000001'
				var tableId = that.pageSetInfo.tableId;
			    var auto_append_json = {'times': String(time),'all_times':String(slider_max),'mainId':String(that.mainId),'tableId':String(tableId)}
				toHtData.json = JSON.stringify(auto_append_json);
				var url = '/update_dicrectTrigger.do?'
				that.$axios.post(url, toHtData).then(res => {
					console.log(res)
				}).catch(error => {
					console.log("服务器异常!", error);
				});
			},
			// 秒转换分钟00:00:00格式
			timeToMinute: function(times) {
				var t;
				if (times > -1) {
					var hour = Math.floor(times / 3600);
					var min = Math.floor(times / 60) % 60;
					var sec = times % 60;
					if (hour > 0) {
						if (hour < 10) {
							t = '0' + hour + ":";
						} else {
							t = hour + ":";
						}
						if (min < 10) {
							t += "0";
						}
						t += min + ":";
						if (sec < 10) {
							t += "0";
						}
						t += sec.toFixed(2);
					} else {
						if (min < 10) {
							t = "0";
						}
						t += min + ":";
						if (sec < 10) {
							t += "0";
						}
						t += sec.toFixed(2);
					}
				}

				t = t.substring(0, t.length - 3);
				return t;
			}
		}
	}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
	/* components/form/kw_video/index.wxss */
</style>
